module.exports = __webpack_public_path__ + "img/1000-3_SERF_2022_Amina-Icon.b88546c7.png";